import React, { useEffect, useState, useCallback, useRef } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';

import { auth, db } from '../../../firebase';
import { doc, getDoc, updateDoc, setDoc } from 'firebase/firestore';
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";

import { saveUserLog } from '../LogandUtils'; // 경로에 맞게 수정

import SEO from '../../SEO';
import Popup from "../../mobile/Popup";
import Loading from "../../Loading";
import MyPageMenu from './MyPageMenu';

import styleClasses from '../css/mobile/MyPage.module.scss';

import imageCompression from 'browser-image-compression';

function ActivityDetail() {
  const { activityID }  = useParams();

  const navigate        = useNavigate();

  const titleRef        = useRef();
  const isSubmitting    = useRef(false);
  
  const [openMenu, setOpenMenu]               = useState(false);
  
  const [uid, setUid]                         = useState(null);
  const [isLoading, setIsLoading]             = useState(true);
  const [isImageLoading, setIsImageLoading]   = useState(false); // 이미지
  const [title, setTitle]                     = useState('');
  const [titleError, setTitleError]           = useState('');
  const [titleErrorText, setTitleErrorText]   = useState('');
  const [date, setDate]                       = useState('');
  // 채널 관련 state
  const [channelType, setChannelType]         = useState("YouTube"); // YouTube, Instagram, 기타
  const [channelName, setChannelName]         = useState('');
  const [channelExtra, setChannelExtra]       = useState(''); // YouTube 영상 ID 또는 게시물 URL
  // 활동 이미지 state (photo)
  const [photo, setPhoto]                     = useState('');
  const [description, setDescription]         = useState('');

  const [buttonLoading, setButtonLoading]     = useState(false)

  const [openPopup, setOpenPopup]             = useState(false);
  const [popupTitle, setPopupTitle]           = useState('');
  const [popupButtonText, setPopupButtonText] = useState('');
  const [customFunction, setCustomFunction]   = useState('');
  
  // 🔹 메뉴 열기
  const toogleMenu = useCallback(
    (event) => {
      const menuIcon = event.target.closest(`.${styleClasses.menuIcon}`);
      const menuBox = event.target.closest(`.${styleClasses.leftContent}`);

      if (openMenu) {
        if (!menuBox) setOpenMenu(false);
      } else {
        if (menuIcon || menuBox) setOpenMenu(true);
      }
    },
    [openMenu, setOpenMenu]
  );

  // 🔹 메뉴 열기 (스크린 전체 이벤트 추가)
  useEffect(() => {
    document.body.addEventListener("click", toogleMenu);

    return () => {
      document.body.removeEventListener("click", toogleMenu);
    };
  }, [toogleMenu]);

  // Firestore에서 /users_data/{uid}/activity/{activityID} 문서를 가져옴
  const fetchActivity = useCallback(async () => {
    if (!uid) return;
    try {
      setIsLoading(true);
      const activityRef = doc(db, "users_data", uid, "activity", activityID);
      const activitySnap = await getDoc(activityRef);
      if (!activitySnap.exists()) {
        console.error("Activity not found");
        setIsLoading(false);
        return;
      }
      const data = activitySnap.data();
      setTitle(data.title || '');
      setDate(data.date || '');
      setDescription(data.description || '');
      // 기존 데이터는 "[YouTube] 카미트루" 형태로 저장되어 있다면 파싱
      if (data.channel) {
        const match = data.channel.match(/^\[(.*?)\]\s*(.*)$/);
        if (match) {
          setChannelType(match[1]);
          setChannelName(match[2]);
        } else {
          setChannelName(data.channel);
        }
      } else {
        setChannelName('');
      }
      // 채널 추가 정보는 videoId 또는 link
      if (data.videoId) {
        setChannelType("YouTube");
        setChannelExtra(data.videoId);
      } else if (data.link) {
        setChannelExtra(data.link);
        setChannelType(data.channelType || "Instagram");
      } else {
        setChannelExtra('');
      }
      // 활동 이미지가 있으면 가져옴, 없으면 photo 상태는 빈 문자열
      setPhoto(data.photo || '');
      setIsLoading(false);
    } catch (error) {
      console.error("Error fetching activity:", error);
      setIsLoading(false);
    }
  }, [uid, activityID]);

  // UID 가져오기
  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        setUid(user.uid);
      }
    });
    return () => unsubscribe();
  }, [navigate]);

  useEffect(() => {
    if (uid) {
      fetchActivity();
    }
  }, [fetchActivity, uid]);

  // 파일 업로드 핸들러 (활동 이미지)
  const handlePhotoChange = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    try {
      setIsImageLoading(true);

      const options = {
        maxWidthOrHeight: 1000,  // 가로 혹은 세로 최대 1000픽셀로 리사이징
        useWebWorker: true,
        maxSizeMB: 0.5,          // 최대 파일 크기를 0.5MB로 제한
        fileType: 'image/jpeg',
        initialQuality: 0.8,
      };
      const compressedFile = await imageCompression(file, options);
      
      const storage = getStorage();
      const storageRef = ref(storage, `users/${uid}/activity/${file.name}`);
      const snapshot = await uploadBytes(storageRef, compressedFile);
      const downloadURL = await getDownloadURL(snapshot.ref);
      
      setIsImageLoading(false);
      setPhoto(downloadURL);
    } catch (error) {
      setIsImageLoading(false);
      console.error("파일 업로드 오류:", error);
      
      setOpenPopup(true);
      setPopupTitle('파일 업로드 중 오류가 발생했습니다.');
      setPopupButtonText('');
      setCustomFunction('');
    }
  };

  // YouTube URL에서 영상 ID 추출 함수
  const extractYouTubeVideoID = (url) => {
    const regExp = /(?:https?:\/\/)?(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:watch\?(?:.*&)?v=|embed\/|v\/))([a-zA-Z0-9_-]{11})/;
    const match = url.match(regExp);
    return match ? match[1] : url;
  };

  const isNew = activityID === "new" || activityID === "add";

    // 🔹 입력값 변경 핸들러
  const handleChange = (e) => {
    if (e.target.id === `title${ activityID }`) {
      setTitleError('');
      setTitleErrorText('');
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
  
    if (!uid) {
      setOpenPopup(true);
      setPopupTitle('로그인이 필요합니다.');
      setPopupButtonText('');
      setCustomFunction('');
      return;
    } else if (title.trim() === '') {
      setTitleError('error');
      setTitleErrorText('타이틀을 입력하세요.');
      
      setOpenPopup(true);
      setPopupTitle('타이틀을 입력하세요.');
      setPopupButtonText('');
      setCustomFunction('');
      return;
    }
  
    try {
      if (isSubmitting.current) return; // 실행 중일 경우 중복 클릭 방지
      isSubmitting.current = true;      // 버튼 비활성화
      setButtonLoading(true);           // 버튼 로딩 표시

      // 1. 채널 정보 구성: 채널명은 "[채널유형] 채널명" 형태로 저장
      //const channel = `[${channelType}] ${channelName}`;
      // 2. 채널 추가 정보: YouTube면 videoId, 그 외에는 link
      const videoId = channelType === "YouTube" ? extractYouTubeVideoID(channelExtra) : "";
      const channelData =
        channelType === "YouTube"
          ? { videoId, link: "" }
          : { link: channelExtra, videoId: "" };

      // 그리고 채널명은 그대로 채널 유형에 맞게 처리
      const channel = `[${channelType}] ${channelName}`;
  
      // 3. 공통 저장 데이터 구성
      const updateData = {
        title,
        date,
        description,
        channel,
        channelType,
        ...channelData,
      };
      if (photo) {
        updateData.photo = photo;
      }
  
      // 4. 사용자 활동 문서 업데이트 (새로운 활동 생성 또는 기존 활동 수정)
      let activityId = activityID;
      let activityRef;
      if (isNew) {
        activityId = `${channelType}_${Date.now()}`;
        activityRef = doc(db, "users_data", uid, "activity", activityId);
        await setDoc(activityRef, updateData);
      } else {
        activityRef = doc(db, "users_data", uid, "activity", activityId);
        await updateDoc(activityRef, updateData);
      }
  
      // 5. act 필드를 확인하여, 이미 뮤지카드로 내보낸 경우 뮤지카드의 활동 문서도 업데이트
      const activitySnap = await getDoc(activityRef);
      if (activitySnap.exists()) {
        const activityData = activitySnap.data();
        if (activityData.act) {
          // act 필드 예시: { apodteam: "events" }
          for (const musicianCardId in activityData.act) {
            const exportType = activityData.act[musicianCardId]; // 예: "events"
            const musicianActivityRef = doc(db, "musicians", musicianCardId, exportType, activityId);
            // 먼저 최근 수정 시간 갱신 후, updateData 병합 업데이트
            await setDoc(musicianActivityRef, { updatedAt: new Date() });
            await setDoc(musicianActivityRef, updateData, { merge: true });
            await saveUserLog('musicard_logs', musicianCardId, 'update', musicianActivityRef.path, 'ActivityDetail');
          }
        }
      }

      isSubmitting.current = false;   // 버튼 활성화
      setButtonLoading(false);        // 버튼 로딩 숨김
      
      setOpenPopup(true);
      setPopupTitle('Activity 정보가 성공적으로 저장되었습니다!');
      setPopupButtonText('목록으로 이동');
      setCustomFunction(() => () => navigate('/my-page/activity'));

      if (isNew) {
        setTitle('');
        setDate('');
        setChannelType('YouTube');
        setChannelExtra('');
        setDescription('');
        setPhoto('');
      }
    } catch (error) {
      console.error("Activity 저장 오류:", error);

      setOpenPopup(true);
      setPopupTitle('Activity 저장 중 오류가 발생했습니다.');
      setPopupButtonText('');
      setCustomFunction('');
    }
  };  

  return (
    <>
      <SEO title={ isNew ? '활동 추가' : '활동 수정' } />
      <div className={styleClasses.myPageMobile}>
        <div className={styleClasses.inner}>
          <div className={styleClasses.title}>
            <h1>Activity Detail</h1>
            <button className={ styleClasses.menuIcon }>
              <div className="commonIcon mobile">
                <i className={`${ openMenu ? 'upWhite' : 'downWhite' } w24`}></i>
              </div>
            </button>
          </div>
          <div className={styleClasses.editContent}>
            <div className={`${ styleClasses.leftContent } ${ openMenu ? styleClasses.open : '' }`}>
              <MyPageMenu currentPage='activity' />
            </div>
            <div className={styleClasses.rightContent}>
              <div className={styleClasses.activityDetail}>
                <div className={styleClasses.detailBox}>
                  {
                    isLoading
                    ?
                    (
                      <Loading />
                    )
                    :
                    (
                      <form onSubmit={handleSubmit} className="commonForm">
                        {/* 활동 이미지 영역 */}
                        <div className="formRow label200">
                          <div className="labelBox">
                            <label htmlFor={`photo${activityID}`}>활동 이미지</label>
                          </div>
                          <div className={`fieldBox ${ styleClasses.uploadImage }`}>
                            <label htmlFor={`photo${activityID}`}>
                              {
                                photo
                                ?
                                (
                                  <img src={ photo } alt={ title } />
                                )
                                :
                                (
                                  // 만약 활동 이미지가 없고 채널이 YouTube이면 videoId 기반 썸네일 표시
                                  channelType === "YouTube"
                                  ? (
                                      channelExtra
                                        ? <img src={`https://img.youtube.com/vi/${extractYouTubeVideoID(channelExtra)}/0.jpg`} alt={title} />
                                        : <div className={styleClasses.placeholder}>유튜브 링크를< br></br>입력해주세요</div>
                                    )
                                  : <div className={styleClasses.placeholder}>이미지 선택</div>
                                )
                              }
                              {
                                  isImageLoading
                                  ?
                                  <span className={`${ styleClasses.imageLoading } w24`}>
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                  </span>
                                  :
                                  <div className="commonIcon">
                                    <i className='uploadWhite w24'></i>
                                  </div>
                                }
                              <div className="commonIcon">
                                <i className="uploadWhite w24"></i>
                              </div>
                              <input type="file" id={`photo${activityID}`} name="photo" onChange={handlePhotoChange} />
                            </label>
                            {/* 이미지 URL 입력란 */}
                            <div className={ styleClasses.underFieldBox }>
                              <div className="fieldBox">
                                <input
                                  type="text"
                                  id={`photoURL${activityID}`}
                                  name="photoURL"
                                  placeholder="또는 이미지 URL 입력"
                                  value={photo}
                                  onChange={(e) => setPhoto(e.target.value)}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        {/* 타이틀 */}
                        <div className="formRow label200">
                          <div className="labelBox">
                            <label htmlFor={`title${activityID}`}>타이틀</label>
                          </div>
                          <div className={`fieldBox ${ titleError }`}>
                            <input
                              type="text"
                              id={`title${activityID}`}
                              name="title"
                              value={title}
                              ref={ titleRef }
                              onChange={ (e) => { setTitle(e.target.value); handleChange(e); } }
                            />
                            <div className="fieldError">
                              <p>{ titleErrorText }</p>
                            </div>
                          </div>
                        </div>
                        {/* 발매일 */}
                        <div className="formRow label200">
                          <div className="labelBox">
                            <label htmlFor={`date${activityID}`}>날짜</label>
                          </div>
                          <div className="fieldBox">
                            <input
                              type="date"
                              id={`date${activityID}`}
                              name="date"
                              value={date}
                              onChange={(e) => setDate(e.target.value)}
                            />
                          </div>
                        </div>
                        {/* 채널명 */}
                        <div className="formRow label200">
                          <div className="labelBox">
                            <label htmlFor={`channelName${activityID}`}>채널명</label>
                          </div>
                          <div className="fieldBox">
                            <input
                              type="text"
                              id={`channelName${activityID}`}
                              name="channelName"
                              value={channelName}
                              onChange={(e) => setChannelName(e.target.value)}
                              placeholder="채널명을 입력하세요"
                            />
                          </div>
                        </div>
                        {/* 채널 유형 선택 (라디오 버튼) */}
                        <div className="formRow label200">
                          <div className="labelBox">
                            <label>채널 유형</label>
                            <div className={`commonIcon toolTip mobile ${ styleClasses.topButtonToolTip }`}>
                              <i className="questionBlack w16"></i>
                              <div className="toolTipText">
                                <p>활동 기록의 저장소(채널)를 선택하세요. <br />신문 기사, 커뮤니티 게시글 등은 ‘기타' <br />를 선택하세요.</p>
                              </div>
                            </div>
                          </div>
                          <div className="fieldBox checkBox">
                            {["YouTube", "Instagram", "기타"].map((type) => (
                              <div key={type} className="eachBox">
                                <input
                                  type="radio"
                                  name="channelType"
                                  id={`channelType${ type }`}
                                  value={type}
                                  checked={channelType === type}
                                  onChange={(e) => setChannelType(e.target.value)}
                                />
                                <label htmlFor={`channelType${ type }`}>{ type }</label>
                              </div>
                            ))}
                          </div>
                        </div>
                        {/* 조건부 입력란: 채널 추가 정보 */}
                        <div className="formRow label200">
                          <div className="labelBox">
                            <label htmlFor={`channelExtra${activityID}`}>
                              {channelType === "YouTube"
                                ? (isNew ? "Youtube 영상 URL" : "Youtube 영상 ID")
                                : channelType === "Instagram"
                                ? "Instagram 게시물 URL"
                                : "기타 게시물 URL"}
                            </label>
                          </div>
                          <div className="fieldBox">
                            <input
                              type="text"
                              id={`channelExtra${activityID}`}
                              name="channelExtra"
                              value={channelExtra}
                              onChange={(e) => setChannelExtra(e.target.value)}
                            />
                          </div>
                        </div>
                        {/* 설명 */}
                        <div className="formRow label200">
                          <div className="labelBox">
                            <label htmlFor={`description${activityID}`}>설명</label>
                          </div>
                          <div className="fieldBox">
                            <textarea
                              id={`description${activityID}`}
                              name="description"
                              value={description}
                              onChange={(e) => setDescription(e.target.value)}
                            ></textarea>
                          </div>
                        </div>
                        {/* 버튼 영역 */}
                        <div className={styleClasses.buttonWrap}>
                          <div className={styleClasses.topButtons}>
                            <div className="commonButton fullwidth">
                              <Link to={`/my-page/activity`} className="secondary">목록</Link>
                            </div>
                            <div className="commonButton fullwidth">
                              <button className="black" type="submit">
                                저장
                                <div className={`buttonLoading ${ buttonLoading && 'active' }`}>
                                  <div></div>
                                  <div></div>
                                  <div></div>
                                </div>
                              </button>
                            </div>
                          </div>
                        </div>
                      </form>
                    )
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Popup open={ openPopup } setOpenPopup={ setOpenPopup } title={ popupTitle } buttonText={ popupButtonText } buttonFunction={ customFunction } />
    </>
  );  
}

export default ActivityDetail;